const ENUM_ALL_EVENT_TYPE_CATEGORY = [
  { text: "Prestation", value: "service" },
  { text: "Autre activité", value: "other" },
  { text: "RH", value: "hr" },
  { text: "Repos", value: "rest" },
];

const ENUM_ALL_STATE = [
  { text: "Devis", value: "draft" },
  { text: "A planifier", value: "to_be_planned" },
  { text: "Planifié", value: "planned" },
  { text: "Confirmé", value: "confirmed" },
  { text: "Réalisé", value: "done" },
  { text: "Traité", value: "processed" },
  { text: "En cours d'archivage", value: "pre_archived" },
  { text: "Archivé", value: "archived" },
  // { text: "Client suspendu", value: "suspended" },
  { text: "Bloqué (impartialité)", value: "blocked" },
];

const ENUM_ALL_STATE_ACTIVE = [
  { text: "Devis", value: "draft" },
  { text: "A planifier", value: "to_be_planned" },
  { text: "Planifié", value: "planned" },
  { text: "Confirmé", value: "confirmed" },
  { text: "Réalisé", value: "done" },
  { text: "Traité", value: "processed" },
  { text: "Client suspendu", value: "suspended" },
  { text: "Bloqué (impartialité)", value: "blocked" },
];

const ENUM_SUPERVISION_COLUMN = [
  {
    text: "Intervenant",
    value: "participant",
    sortable: true,
  },
  {
    text: "Nature d'événement",
    value: "subtype",
    sortable: true,
  },
  { text: "Durée théorique", value: "duration", sortable: false, align: "end" },
  {
    text: "Durée réelle (hors pause)",
    value: "cumulativeDuration",
    sortable: false,
    align: "end",
  },
  {
    text: "Créneaux horaires",
    value: "timeSlots",
    sortable: true,
  },
  { text: "Date du premier créneau", value: "firstTimeSlot", sortable: true },
  { text: "Enseigne", value: "referenceStore", sortable: false },
  { text: "Date limite", value: "deadline", sortable: true },
  { text: "Report", value: "report", sortable: true },
  { text: "Réf. client Divalto", value: "referenceBusinessDivalto" },
  { text: "Statut client", value: "stateBusiness", sortable: true },
  { text: "Quantité", value: "quantity", sortable: false, align: "end" },
  { text: "Selection", value: "select" },
  { text: "Statut", value: "state", sortable: false },
  { text: "Type d'utilisateur", value: "customerType", sortable: true },
  { text: "Dossiers", value: "eventTypeFolders", sortable: false },
  { text: "Groupe", value: "businessGroupCode", sortable: true, align: "end" },
];

const ENUM_SUPERVISION_COLUMN_NOT_REMOVABLE = [
  { text: "Code postal", value: "postcode", sortable: true },
  { text: "Ville", value: "city", sortable: false },
  { text: "Réf. client", value: "referenceBusiness", sortable: true },
  { text: "Commentaire", value: "description", sortable: false },
  { text: "N° Commande", value: "order_number", sortable: true },
  { text: "Details", value: "details", sortable: false, class: "text-break" },
];

const ENUM_DEFAULT_SUPERVISION_COLUMN = [
  "participant",
  "subtype",
  "duration",
  "description",
  "cumulativeDuration",
  "timeSlots",
  "referenceStore",
  "referenceBusiness",
  "postcode",
  "city",
  "Statut",
];

const ENUM_DEFAULT_SUPERVISION_FILTERS_ARRAY = [
  "managers",
  "customers",
  "dates",
  "datesLimit",
  "datesReport",
  "subtypes",
  "states",
  "folders",
  "customerTypes",
  "businessGroups",
  "businesses",
  "references",
  "businessStates",
];

const ENUM_DEFAULT_SUPERVISION_FILTERS_SCALAR = [
  "store",
  "city",
  "department",
  "category",
  "report",
];

const CUSTOMER_TYPE_LEFT = { text: "Ayant quitté AQUALEHA", value: "left" };

const ENUM_ALL_CUSTOMER_TYPE = [
  { text: "Pôle conseil", value: "conseil" },
  { text: "Pôle inspection", value: "inspection" },
  { text: "Autre service", value: "other" },
  { text: "Sous traitance", value: "outsourcing" },
  { ...CUSTOMER_TYPE_LEFT },
];

const EVENT_COLOR_DEFAULT = {
  border: "#71717a",
  text: "#27272a",
  background: "#e4e4e7",
};
const EVENT_COLOR_RULE = {
  border: "#eab308",
  text: "#854d0e",
  background: "#fef08a",
};
const EVENT_COLOR_RED = {
  border: "#ef4444",
  text: "#991b1b",
  background: "#fecaca",
};

const ENUM_EVENT_COLOR_BY_STATE = {
  planned: {
    border: "#3b82f6",
    text: "#1e40af",
    background: "#bfdbfe",
  },
  confirmed: {
    border: "#f97316",
    text: "#9a3412",
    background: "#fed7aa",
  },
  processed: {
    border: "#16a34a",
    text: "#166534",
    background: "#bbf7d0",
  },
  done: EVENT_COLOR_RED,
  to_be_planned: EVENT_COLOR_DEFAULT,
  archived: EVENT_COLOR_DEFAULT,
  suspended: EVENT_COLOR_DEFAULT,
  pre_archived: EVENT_COLOR_DEFAULT,
};

const STATUS_CADRE = "cadre";
const STATUS_RESP_SEC = "resp_sec";
const STATUS_ETAM = "etam";
const STATUS_PT = "pt";

const BUSINESS_STATE_ACTIVE = "active";
const BUSINESS_STATE_SUSPENDED = "suspended";
const BUSINESS_STATES = [BUSINESS_STATE_ACTIVE, BUSINESS_STATE_SUSPENDED];

export {
  ENUM_ALL_EVENT_TYPE_CATEGORY,
  ENUM_ALL_STATE,
  ENUM_SUPERVISION_COLUMN,
  ENUM_DEFAULT_SUPERVISION_COLUMN,
  ENUM_ALL_STATE_ACTIVE,
  ENUM_SUPERVISION_COLUMN_NOT_REMOVABLE,
  ENUM_DEFAULT_SUPERVISION_FILTERS_ARRAY,
  ENUM_DEFAULT_SUPERVISION_FILTERS_SCALAR,
  ENUM_ALL_CUSTOMER_TYPE,
  CUSTOMER_TYPE_LEFT,
  EVENT_COLOR_DEFAULT,
  EVENT_COLOR_RULE,
  EVENT_COLOR_RED,
  ENUM_EVENT_COLOR_BY_STATE,
  STATUS_CADRE,
  STATUS_RESP_SEC,
  STATUS_ETAM,
  STATUS_PT,
  BUSINESS_STATE_ACTIVE,
  BUSINESS_STATE_SUSPENDED,
  BUSINESS_STATES,
};

export const EVENT_TYPE_LINK_TYPE_CV = /** @type {const} */ ("cv");
export const EVENT_TYPE_LINK_TYPES = /** @type {const} */ ([
  EVENT_TYPE_LINK_TYPE_CV,
]);

export const FIELD_APPLICATION_NONE = /** @type {const} */ ("none");
export const FIELD_APPLICATION_ASPIC = /** @type {const} */ ("aspic");
export const FIELD_APPLICATION_EKTIMO = /** @type {const} */ ("ektimo");
export const FIELD_APPLICATION_EKTIMO_OR_ASPIC = /** @type {const} */ (
  "ektimo ou aspic"
);
export const FIELD_APPLICATION_SMARTOF = /** @type {const} */ ("smartof");

export const FIELD_APPLICATIONS = [
  FIELD_APPLICATION_NONE,
  FIELD_APPLICATION_ASPIC,
  FIELD_APPLICATION_EKTIMO,
  FIELD_APPLICATION_EKTIMO_OR_ASPIC,
  FIELD_APPLICATION_SMARTOF,
];
